<!-- Spinner -->
<div *ngIf="isLoadingg" class="spinner-center-wrapper">
  <div class="spinner-center"></div>
  Redirecting ....
</div>

<app-alert></app-alert>
<router-outlet></router-outlet>
 <!-- <div style="/* width: fit-content; *//* margin: auto; *//* margin-left: 30%; *//* margin-top: 15%; */height: 100vh;display: flex;flex-direction: column;align-items: center;justify-content: center;">
  <img src="../assets/images/indusindHeaderLogo.png" alt="" style="
  max-width: 100%;
"> 
   <h1 style="text-align: center;">Application is under maintenance</h1>

 </div> -->
